import React, { useEffect, useRef, useState, useReducer } from "react";
import ReactDOM from "react-dom";
import eventBus from "../../../../../util/eventBus";
import "./index.less";
import "@kdcloudjs/kdesign/dist/kdesign.css";
import Axis from "./components/Axis/Axis";
import chroma from "chroma-js";
/**
 * 在setHtml中声明Root类，使用ReactDOM.render将其渲染在model.dom中
 * 在Root类的componentDidMount里，声明一个订阅，用于接收后端更新发过来的消息，从而去更新组件
 * 在update里，发布一个消息，当后端插件给自定义控件传递新数据时，就能将消息发布给Root
 * 在Root类的componentWillUnmount里，取消订阅
 * 在destoryed里，使用ReactDOM.unmountComponentAtNode卸载Root
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */

(function (KDApi) {
  function talentVisualMap(model) {
    this._setModel(model);
  }

  talentVisualMap.prototype = {
    _setModel: function (model) {
      this.model = model;
      console.log(KDApi.getLangMsg(model, "tableView"), "tableView---xxx");
      this.I18N = (key) => KDApi.getLangMsg(model, key);
    },
    init: function (props) {
      console.log("-----init", this.model.style, props);
      setHtml(this.model, props, { I18N: this.I18N });
    },
    update: function (props) {
      console.log("-----update", this.model, props);
      eventBus.pub(this.model, "update", props);
    },
    destoryed: function () {
      console.log("-----destoryed", this.model);
      ReactDOM.unmountComponentAtNode(this.model.dom);
    },
  };

  var setHtml = function (model, primaryProps, { I18N }) {
    KDApi.loadFile("./css/index.css", model, () => {
      const Root = (props) => {
        const [model, setModel] = useState(props.model);
        const [globalData, setGlobalData] = useState(
          props.customProps?.data?.data
        );
        const { colorScheme } = globalData?.gridData || {};

        useEffect(() => {
          document.documentElement.style.setProperty(
            "--talent-visual-map-theme-color",
            colorScheme
          );
          const opacityColor = chroma(colorScheme || "#ffffff")
            .alpha(0.1)
            .css();

          document.documentElement.style.setProperty(
            "--talent-visual-map-theme-opacity-color",
            opacityColor
          );
        }, [colorScheme]);

        useEffect(() => {
          const updateSub = eventBus.sub(model, "update", (customProps) => {
            setGlobalData(customProps?.data?.data);
          });
          return () => {
            eventBus.unsub(updateSub);
          };
        }, []);

        console.log(globalData, "globalData");
        return (
          <div className="talent-visual-map-container">
            {globalData ? <Axis globalData={globalData} model={model} /> : null}
          </div>
        );
      };

      ReactDOM.render(
        <Root model={model} customProps={primaryProps} I18N={I18N} />,
        model.dom
      );
    });
  };

  // 注册自定义组件
  KDApi.register("talentVisualMap", talentVisualMap, { isMulLang: true });
})(window.KDApi);
